import axios from 'axios'
import cookie from './cookie'
import {Message,MessageBox} from "element-ui";
import getUrl from '../../static/config.json'

const token = {};

token.token_key = 'access_token_ul_wf';//token authorization
token.token_role_name = "role_name_ul_wf";//角色名称
token.token_usrname = "usr_name_ul_wf";
token.refresh_key = 'refresh_key_ul_wf';

/**
 * 提示函数
 * 显示2秒后关闭
 */
function tip(msg,type = 'error',time = 2000 ){
  Message({
    message: msg,
    type: type,
    duration: time,
    showClose: true
  });
}

// 解析后台返回code
function analysisReturnCode(data){
  switch (data.code) {
    case 201: // 表示认证错误
      tip(data.message);
      break;
    case 202: // 授权失败
      cookie.removeCookie(token.token_key);
      cookie.removeCookie(token.refresh_key);
      tip('登录信息过期，请重新登录');
      // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
      router.replace({
        path: '/login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      });
      break;
    case 403: // 授权失败
      cookie.removeCookie(token.token_key);
      cookie.removeCookie(token.refresh_key);
      tip('登录信息过期，请重新登录');
      // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
      router.replace({
        path: '/login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      });
      break;
    case 203: // token验证失败
      cookie.removeCookie(token.token_key);
      cookie.removeCookie(token.refresh_key);
      // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
      router.replace({
        path: '/login',
        query: {
          redirect: router.currentRoute.fullPath
        }
      });
      tip('登录信息过期，请重新登录');
      break;
    case 205:
      tip('API不支持前端指定的数据格式'+ data.message);
      break;
    case 206:
      tip('前端发送的请求到服务器所需的时间太长'+ data.message);
      break;
    // case -101:
    //   tip('服务暂停'+ data.message);
    //   break;
    // case -102:
    //   tip('服务器内部错误'+ data.message);
    //   break;
    // case -103:
    //   tip('接口不存在'+ data.message);
    //   break;
    // case -104:
    //   tip('缺少必要参数'+ data.message);
    //   break;
    // case -105:
    //   tip('不支持的MediaType'+ data.message);
    //   break;
    // case -106:
    //   tip('参数错误:'+ data.message);
    //   break;
    // case -107:
    //   tip('任务过多，系统繁忙'+ data.message);
    //   break;
    // case -108:
    //   tip('任务超时'+ data.message);
    //   break;
    // case -109:
    //   tip('非法请求'+ data.message);
    //   break;
    // case -110:
    //   tip('请求长度超过限制'+ data.message);
    //   break;
    default:
      tip(data.message? data.message:data.msg);
  }
}


function refresh(callBack){
  axios.post(getUrl.API_ROOT + '/Usr/RefreshToken?Authorization=' + cookie.getCookie(token.refresh_key), {})
    .then(function (res) {
      if (res.data.code == 0) {
        cookie.setCookie(token.token_key,res.data.data.authorization);
        callBack();
      } else {
        router.replace({
          path: '/login',
          query: {
            redirect: router.currentRoute.fullPath
          }
        });
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}

function fileLinkToStreamDownload(url, fileName, type) {
  let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;
  let that = this;
  // modify by xxt 2024-08-15 修改只判断链接是否为空
  // if (!reg.test(url)) {
  if (url == null) {
  // modify by xxt 2024-08-15 修改只判断链接是否为空
    throw new Error("传入参数不合法,不是标准的文件链接");
  } else {
    let xhr = new XMLHttpRequest();
    xhr.open('get', url, true);
    xhr.setRequestHeader('Content-Type', `application/${type}`);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (this.status == 200) {
        //接受二进制文件流
        let blob = this.response;
        downloadExportFile(blob, fileName, type)
      }
    }
    xhr.send();
  }
};

function downloadExportFile(blob, tagFileName, fileType) {
  let downloadElement = document.createElement('a');
  let href = blob;
  if (typeof blob == 'string') {
    downloadElement.target = '_blank';
  } else {
    href = window.URL.createObjectURL(blob); //创建下载的链接
  }
  downloadElement.href = href;
  downloadElement.download = tagFileName + '.' + fileType; //下载后文件名
  document.body.appendChild(downloadElement);
  downloadElement.click(); //点击下载
  document.body.removeChild(downloadElement); //下载完成移除元素
  if (typeof blob != 'string') {
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }
};


export default {
  tip:tip,
  analysisReturnCode:analysisReturnCode,
  token:token,
  refresh:refresh,
  fileLinkToStreamDownload:fileLinkToStreamDownload,
  ETC_ROOT:getUrl.ETC_ROOT,
  API_ROOT:getUrl.API_ROOT,
  DC_ROOT:getUrl.DC_ROOT
}



// WEBPACK FOOTER //
// ./src/service/public.js